import { useActiveForm } from 'pages/claims/components/ClaimFormProvider';
import { AllKeys } from 'pages/claims/components/ModalComponents/ModalSections/Section';
import { useMemo } from 'react';

interface UseGetModalSectionBorderColorProps {
  keys: AllKeys[];
}

export const useGetModalSectionBorderColor = ({
  keys,
}: UseGetModalSectionBorderColorProps): 'red' | 'green' => {
  const { form, prefix, isBulk } = useActiveForm();

  return useMemo(() => {
    if (!form) return 'green';

    const errors = form.errors;

    const makePath = (key: AllKeys): string => {
      return prefix ? `${prefix}.${key}` : key;
    };

    for (const key of keys) {
      const path = makePath(key);
      if (errors[path]) {
        return 'red';
      }
      const nested = path + '.';
      if (Object.keys(errors).some((e) => e.startsWith(nested))) {
        return 'red';
      }
    }

    return 'green';
  }, [form, form.errors, form.getValues(), prefix, isBulk, keys]);
};
